import axios from 'axios';

// this util is for local ui development only, do not use this for any deployed builds
const getAndSetLocalAuthCookies = async (
  url: string,
  loadingCb?: (loadingState: boolean) => void
) => {
  try {
    loadingCb && loadingCb(true);

    const response = await axios.get(url);
    const htmlString = response.data;

    const accessTokenRegex =
      /<input type="hidden" name="access_token" value="(.*?)"/;
    const idTokenRegex = /<input type="hidden" name="id_token" value="(.*?)"/;

    const accessTokenMatch = htmlString.match(accessTokenRegex);
    const idTokenMatch = htmlString.match(idTokenRegex);

    loadingCb && loadingCb(false);

    if (accessTokenMatch && accessTokenMatch[1]) {
      const accessTokenValue = accessTokenMatch[1];
      document.cookie = `mpr_access_token=${accessTokenValue};path=/`;
      console.log('Access token value:', accessTokenValue);
    } else {
      console.error('Access token not found');
    }

    if (idTokenMatch && idTokenMatch[1]) {
      const idTokenValue = idTokenMatch[1];
      document.cookie = `mpr_id_token=${idTokenValue};path=/`;
      console.log('ID token value:', idTokenValue);
    } else {
      console.error('ID Token not found');
    }
    // @ts-expect-error - window.location assignment
    window.location = '/';
  } catch (error) {
    console.error('Error fetching URL:', error);
  }
};

export default getAndSetLocalAuthCookies;
